import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useAuth } from "@/context/AuthContext";
import { planAllows } from "@/lib/format";
import { Users, FileText, Receipt, Briefcase } from "lucide-react";

export default function QuickCreate({ open, onOpenChange }) {
  const nav = useNavigate();
  const { user } = useAuth();
  const plan = user?.business?.plan || "free";
  const go = (path) => { onOpenChange(false); nav(path); };

  const ACTIONS = [
    { label: "New customer", icon: Users, path: "/app/customers?new=1", feature: "customers" },
    { label: "New quote", icon: FileText, path: "/app/quotes?new=1", feature: "quotes" },
    { label: "New invoice", icon: Receipt, path: "/app/invoices?new=1", feature: "invoices" },
    { label: "New job", icon: Briefcase, path: "/app/jobs?new=1", feature: "jobs" },
  ].filter((a) => planAllows(plan, a.feature));

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader><DialogTitle>Quick create</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-3 pt-2">
          {ACTIONS.map((a) => (
            <button key={a.label} onClick={() => go(a.path)} data-testid={`quick-${a.label.toLowerCase().replace(/\s/g, "-")}`}
              className="flex flex-col items-center gap-2 p-5 rounded-xl border border-slate-200 hover:border-blue-400 hover:bg-blue-50 transition-all">
              <span className="grid place-items-center h-11 w-11 rounded-xl bg-blue-50 text-blue-accent"><a.icon size={22} /></span>
              <span className="text-sm font-medium text-navy">{a.label}</span>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
